module.exports = __webpack_public_path__ + "static/media/3DPPA23.a7bd25a2.jpg";